import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import { jsxs, jsx } from 'react/jsx-runtime';
import { ArrowRight } from '@dls/assets/icons';
import { Column, Grid, theme as theme$1, Row, Text } from '@dls/web';
import { useState, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { remCalc } from '../../../../../helpers/styles.js';
import '@geit/ui-components';
import theme from '../../../../../theme/index.js';
import HamburgerMenuHeader from './HamburgerMenuHeader.js';
import MobilePublicSubMenu from './MobilePublicSubMenu.js';
const SCHamburgerMenu = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: ", ";\n  /* border-top: 4px solid ", "; */\n  opacity: 0;\n  overflow-y: auto;\n  visibility: hidden;\n  z-index: 99999;\n\n  transition: all 400ms ease-out;\n  transform: translate(-200px, 0);\n\n  ", ";\n\n  ", ";\n"])), props => props.theme === "dark" ? theme.colours.darkslate : theme.colours.white, theme.colours.singtelred, props => props.isHamburgerMenuOpen && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      transform: translate(0, 0);\n      opacity: 1;\n      visibility: visible;\n    "]))), theme.media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  transform: translate(-100vw, 0);\n  "]))));
const SCColumnPrimaryMenuItem = styled(Column)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0 ", ";\n"])), remCalc(8));
const MobilePublicMenu = _ref => {
  let {
    isHamburgerMenuOpen,
    onClose,
    theme: theme2,
    menuItems = []
  } = _ref;
  var _a;
  const [selectedParent, setSelectedParent] = useState(void 0);
  if (typeof document !== "undefined" && isHamburgerMenuOpen) {
    document.body.style.overflow = "hidden";
  }
  if (typeof document !== "undefined" && !isHamburgerMenuOpen) {
    document.body.removeAttribute("style");
  }
  const onMenuClose = useCallback(() => {
    setSelectedParent(void 0);
    onClose == null ? void 0 : onClose();
  }, []);
  return /* @__PURE__ */jsxs(SCHamburgerMenu, {
    isHamburgerMenuOpen,
    theme: theme2,
    children: [/* @__PURE__ */jsx(HamburgerMenuHeader, {
      isFirstLevel: !selectedParent,
      onBack: () => setSelectedParent(void 0),
      onClose: onMenuClose
    }), /* @__PURE__ */jsx(SCMenuGrid, {
      isFirstLevel: !selectedParent,
      children: /* @__PURE__ */jsx(Row, {
        middle: "xs",
        children: /* @__PURE__ */jsxs(SCColumnPrimaryMenuItem, {
          xs: 12,
          children: [!selectedParent && /* @__PURE__ */jsx(SCFirstLevelMenu, {
            children: menuItems.filter(item => item.item.active).map((menuItem, index) => {
              return /* @__PURE__ */jsxs(SCFirstLevelMenuItem, {
                theme: theme2,
                onClick: () => setSelectedParent(menuItem),
                children: [/* @__PURE__ */jsx(Text, {
                  type: "boldBody",
                  theme: theme2,
                  children: menuItem.item.title
                }, index), /* @__PURE__ */jsx(ArrowRight, {
                  size: 16
                })]
              });
            })
          }), /* @__PURE__ */jsx(MobilePublicSubMenu, {
            isOpen: !!selectedParent,
            parentMenuTitle: (_a = selectedParent == null ? void 0 : selectedParent.item) == null ? void 0 : _a.title,
            menuItems: selectedParent == null ? void 0 : selectedParent.subMenu
          })]
        })
      })
    })]
  });
};
const SCMenuGrid = styled(Grid)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), props => props.isFirstLevel ? css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          padding-top: 0px;\n          padding-bottom: 0px;\n        "]))) : "");
const SCFirstLevelMenu = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"])));
const SCFirstLevelMenuItem = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  & > p {\n    color: ", ";\n  }\n\n  & svg path {\n    fill: ", ";\n  }\n"])), props => props.theme === "dark" ? theme$1.main.colours.white : theme$1.main.colours.tertiary.l2, props => props.theme === "dark" ? theme$1.main.colours.white : theme$1.main.colours.tertiary.l2);
export { SCHamburgerMenu, MobilePublicMenu as default };